import React, { useEffect, useState, useMemo } from "react";
import { formatNumberWithCommas, formatDate } from '../../../common/utility'

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";
import * as XLSX from 'xlsx';

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import TableContainerV1 from "components/Common/TableContainerV1";

import { getSalePerformanceReport } from "../../../helpers/UAM/report.helper"


const SalePerformanceReport = props => {

  //meta title
  document.title = "Sales Performance Report | DMS";

  const [salePerformanceData, setSalePerformanceData] = useState([])

  const [pagination, setPagination] = useState({ pageIndex: 0, pageCount: 0, totalRecords: 0, })
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [filters, setFilters] = useState({});
  const [columnId, setColumnId] = useState("totalAmount");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [sortingOptions, setSortingOptions] = useState({
    column: "", isAsc: false, optionalColumn: ["paymentDetails", "deliveryShippingID", "deliveryShippingDate"],
  });

  // Customber Column
  const columns = useMemo(
    () => [
      {
        Header: 'Product Code',
        accessor: 'productId',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
          ;
        }
      },
      {
        Header: 'Product Name',
        accessor: 'productName',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Units Sold',
        accessor: 'quantity',
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value ? cellProps.value : "";
        }
      },
      {
        Header: 'Total Sales Amount',
        accessor: 'totalAmount',
        filterable: true,
        alignRight: true,
        Cell: (cellProps) => (
          <div style={{ textAlign: 'right' }}>
            {formatNumberWithCommas(cellProps.value ? cellProps.value : "")}
          </div>
        ),
      }
    ],
    []
  );

  useEffect(() => {
    fetchSalePerformanceReport({})
  }, [])

  const fetchSalePerformanceReport = (data) => {
    getSalePerformanceReport(data)
      .then((response) => {
        if (response.status && response.code == 200) {
          setSalePerformanceData(response.data.data);
          const { totalItems, totalPages, currentPage } = response.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setPagination({ totalRecords: 0 })
          setSalePerformanceData([])
        }
      })
      .catch((err) => { console.log(err) })
  }

  const handlePageChange = (page, pageSize, searchKey = searchValue, columnName = columnId, sortingOrder = sortingOrderStatus) => {
    setPageSize(pageSize);
    setCurrentPage(page)
    fetchSalePerformanceReport({ page, limit: pageSize, searchKey, columnName, sortingOrder })
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(currentPage, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    const newValue = value !== undefined ? value : "";
    setSearchValue(newValue);
    handlePageChange(1, pageSize, newValue);
  };
  const handleClearSearch = () => {
    setSearchValue("");
    handlePageChange(1, pageSize, "");
  };

  const downloadExcel = () => {
    let dataWithModifiedCol = salePerformanceData.map(report => {
      let newReport = {
        "Product Code": report.productId,
        "Product Name": report.productName,
        "Unit Sold": report.quantity,
        "Total Sales Amount": report.totalAmount
      }
      return newReport
    })

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    const sheetData = XLSX.utils.json_to_sheet(dataWithModifiedCol);
    // Add the sheet to the workbook
    XLSX.utils.book_append_sheet(workbook, sheetData, 'SalePerformanceReport');
    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'sale_performance_report.xlsx');
  };

  const buttonSection = (
    <div className="text-sm-end">

      <Button
        type="button"
        color="success"
        className="btn-rounded mb-2 me-2"
        onClick={downloadExcel}
        disabled={salePerformanceData.length > 0 ? false : true}
      >
        <i className="bx bx-archive-in me-1" />
        {'Download'}
      </Button>

    </div>
  );
  // const customeFilterSection = (
  //   <div className="d-flex align-items-center justify-content-start">
  //     <div>
  //       <div className="form-check">
  //         <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
  //         <label className="form-check-label" htmlFor="flexCheckDefault">
  //           Default checkbox
  //         </label>
  //       </div>
  //       <div className="form-check">
  //         <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
  //         <label className="form-check-label" htmlFor="flexCheckChecked">
  //           Checked checkbox
  //         </label>
  //       </div>
  //     </div>
  //     <div className="text-sm-start">
  //       <select className="form-select  me-3 show-dropdown" style={{ width: "150px" }}
  //         value={filters.status}
  //         onChange={(e) => {
  //           const value = e.target.value;
  //           // handleStatusChange(value)
  //         }}
  //       >
  //         <option selected={filters.status == 'pending'} value={'pending'}>January</option>
  //         <option selected={filters.status == 'win'} value={'win'}>February</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>March</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>April</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>May</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>June</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>July</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>August</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>September</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>October</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>November</option>
  //         <option selected={filters.status == 'lost'} value={'lost'}>December</option>
  //       </select>
  //     </div>
  //   </div>
  // )

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Reports" breadcrumbItem="Sales Performance Report" />
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>

                <TableContainerV1
                  columns={columns}
                  data={salePerformanceData}
                  pagination={pagination}
                  handlePageChange={handlePageChange}
                  handleSearchFilter={handleSearchFilter}
                  customSection={buttonSection}
                  sortOptions={sortingOptions}
                  handleSortColumn={handleSortColumn}
                  handleClearSearch={handleClearSearch}
                  searchHelperText="Search by Product Name"
                  className="custom-header-css"
                // customFilterSection={customeFilterSection}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SalePerformanceReport;
